export interface Loader {
    require<T>(name: string): Promise<T>;
    module<T>(name: string, deps: string[], loader: () => Promise<T>, asyncHint?: boolean): void;
    unload(name: string): void
}

let _currentLoader: Loader|null = null;
export function setModuleLoader(loader: Loader) {
    _currentLoader = loader;
}
export function getModuleLoader(): Loader {
    if (_currentLoader === null) {
        console.log("[Loader] Using default module loader.");
        const ModuleLoader = require("@/platform/modules").default;
        _currentLoader = ModuleLoader;
    }

    return {
        async require(...args) {
            return await _currentLoader!.require(...args);
        },
        module(...args) {
            return _currentLoader!.module(...args);
        },
        unload(...args) {
            return _currentLoader!.unload(...args);
        }
    }
}
